module.exports = __webpack_public_path__ + "static/media/measure3.a4476b37.png";